/* eslint-disable @typescript-eslint/no-explicit-any */
export function isObject<T = Record<string, any>>(value: any): value is T {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

export function isEmptyObject(value: any): boolean {
  return isObject(value) && Object.keys(value).length === 0;
}
